// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from CalendarViewCellsGrid.module.scss  */
.CalendarViewCellsGrid-module-Root_16I {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  column-count: 7; }
  .CalendarViewCellsGrid-module-Root_16I::before {
    position: absolute;
    left: -0.125rem;
    display: block;
    width: 1px;
    height: 60%;
    content: '';
    background-color: var(--calendar-divider); }
  .CalendarViewCellsGrid-module-Root_16I::after {
    position: absolute;
    bottom: -1rem;
    left: 50%;
    display: block;
    width: 80%;
    height: 1px;
    content: '';
    background-color: var(--calendar-divider);
    transform: translateX(-50%); }

.CalendarViewCellsGrid-module-Weekday_1jv {
  padding: 0.25rem;
  text-align: center;
  color: #9199a3; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Calendar/View/CellsGrid/CalendarViewCellsGrid.css"],"names":[],"mappings":"AAAA,sDAAsD;AACtD;EACE,aAAa;EACb,qCAAqC;EACrC,eAAe,EAAE;EACjB;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,UAAU;IACV,WAAW;IACX,WAAW;IACX,yCAAyC,EAAE;EAC7C;IACE,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,cAAc;IACd,UAAU;IACV,WAAW;IACX,WAAW;IACX,yCAAyC;IACzC,2BAA2B,EAAE;;AAEjC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc,EAAE","sourcesContent":["/*  imported from CalendarViewCellsGrid.module.scss  */\n.CalendarViewCellsGrid-module-Root_16I {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  column-count: 7; }\n  .CalendarViewCellsGrid-module-Root_16I::before {\n    position: absolute;\n    left: -0.125rem;\n    display: block;\n    width: 1px;\n    height: 60%;\n    content: '';\n    background-color: var(--calendar-divider); }\n  .CalendarViewCellsGrid-module-Root_16I::after {\n    position: absolute;\n    bottom: -1rem;\n    left: 50%;\n    display: block;\n    width: 80%;\n    height: 1px;\n    content: '';\n    background-color: var(--calendar-divider);\n    transform: translateX(-50%); }\n\n.CalendarViewCellsGrid-module-Weekday_1jv {\n  padding: 0.25rem;\n  text-align: center;\n  color: #9199a3; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
